<template>
  <div class="card p-1">
    <div class="grid">

      <!-- Titulo Oficios -->
      <div class="col-9 xl:col-3 lg:col-3 md:col-3 sm:col-5 p-2 flex justify-content-end">
        <h5 class="p-2 mt-3 tablaTitle">
          <i class="fa-solid fa-file-contract fa-flip"
            style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
          <span class="px-2">
            Creación de oficios
          </span>
        </h5>
      </div>
      <!-- Titulo Oficios -->

      <div class="col-3 xl:col-2 lg:col-2 md:col-2 sm:col-2 flex justify-content-start">
        <dialogAyudaCreacionOficios />
      </div>

      <div class="col-12 xl:col-7 lg:col-7 md:col-7 sm:col-5 p-2 text-center">
        <dialogCrearFichaTabla />
      </div>

      <dialogClonar @valor="limpiarFilter" :modalVal='modalVal' />
      <!-- Tabs -->
      <div class="col-12 p-1 mb-8">
        <div class="card">
          <TabViewVue class="tabview-custom tabsTablas" :activeIndex="parseInt(selectedTab)">

            <!-- Tabla de Creados -->
            <TabPanelVue>
              <template #header>
                <div class="divTabs" @click="getFichasCreacion">
                  <BadgeVue :value="contadorOficiosNuevos" class="titulosPestanasContador">
                  </BadgeVue>
                  <!-- Contador para oficios -->

                  <i class="fa-solid fa-file fa-bounce px-2"
                    style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;">
                  </i>
                  <span class="">Oficios nuevos</span>

                </div>

                <!-- Contador para oficios -->

              </template>

              <div class="card p-1">
                <DataTable :value="fichas" responsiveLayout="scroll" :lazy="true" :totalRecords="totalRecordsNuevos"
                  @page="onPageNuevos($event)" @filter="onFilterNuevos($event)" v-model:filters="filtersNuevos"
                  stripedRows sortField="numeroOficio" :sortOrder="-1" :paginator="true" :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort dataKey="numeroOficio" class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-2">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <!-- <i class="pi pi-search" /> -->
                            <InputTextV v-model="filtersNuevos['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" autocomplete="off" name="table_search" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>
                    <InlineMessageVue class="msgTablas">
                      <i class="fa-solid fa-triangle-exclamation fa-beat px-2" style="--fa-animation-duration: 1.5s">
                      </i>
                      No se encontraron oficios nuevos.
                    </InlineMessageVue>
                  </template>

                  <ColumnVue v-for="col of columns" :field="col.field" :header="col.header" :key="col.field"
                    :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>

                  <ColumnVue field="vistos_buenos" :sortable="true" :exportable="false" style="min-width: 12rem"
                    header="VistosBuenos" class="tablaOficiosData">
                    <template #body="slotProps">
                      <span v-if="slotProps.data.vistos_buenos === ''">
                        N/A
                      </span>
                      <span v-else>
                        <ButtonVue label="Ver Vistos buenos" icon="pi pi-eye" class="p-button-text"
                          @click="verVistosBuenos(slotProps.data)" />
                      </span>
                    </template>
                  </ColumnVue>

                  <ColumnVue field="vobo_ccp" :sortable="true" :exportable="false" style="min-width: 8rem"
                    header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- #########################################################SIN ANEXO################################################################ -->

                      <!-- Oficio Creado Estado 1 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 1 && slotProps.data.vobo_ccp == 0 && slotProps.data.anexo == 0)"
                        label="Elegir una opción" icon="fa-solid fa-question fa-beat"
                        style="--fa-animation-duration: 1.5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado1 w-full"
                        v-tooltip.top="'La ficha ha sido creada, puedes añadir vistos buenos opcionalmente, después crear el oficio o adjuntarlo.'"
                        :model="[
                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Añadir vistos buenos y con copia para',
                            icon: 'pi pi-plus-circle',
                            command: () => {
                              openDialogVoBo(
                                'AnadirVB',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Crear oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialog(
                                'CrearPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,

                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,

                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,

                                slotProps.data.cargoFirmante,
                                slotProps.data.firmante,
                              );
                            },
                          },
                          {
                            label: 'Adjuntar oficio',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'AdjuntarPDF',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },


                        ]" />
                      <!-- Oficio Creado Estado 1 -->

                      <!-- Oficio Creado con CCP Estado 1 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 1 && slotProps.data.vobo_ccp == 2 && slotProps.data.anexo == 0)"
                        label="C.C.P. añadido" icon="fa-solid fa-question fa-beat"
                        style="--fa-animation-duration: 1.5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado1CCP w-full"
                        v-tooltip.top="'La ficha ha sido creada y se han añadido vistos buenos.'" :model="[
                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Crear oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialog(
                                'CrearPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,

                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,

                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,

                                slotProps.data.cargoFirmante,
                                slotProps.data.firmante,
                              );
                            },
                          },
                          {
                            label: 'Adjuntar oficio',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'AdjuntarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- Oficio Creado con CCP Estado 1 -->

                      <!-- Oficio Adjunto Estado 2 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 2 && slotProps.data.adjuntado == 1 && slotProps.data.vobo_ccp == 0 && slotProps.data.contestacion == 0 && slotProps.data.anexo == 0)"
                        label="Oficio adjunto" icon="fa-solid fa-paperclip fa-beat"
                        style="--fa-animation-duration: 5s; "
                        class="p-button-sm p-button-secondary splitGeneracionEstado2 w-full"
                        v-tooltip.top="'Se adjunto un archivo, modificalo si es necesario.'" :model="[
                          {
                            label: 'Visualizar archivo adjunto',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Añadir vistos buenos y con copia para',
                            icon: 'pi pi-plus-circle',
                            command: () => {
                              openDialogVoBo(
                                'AnadirVB',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio adjunto',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'ModificadoAdjuntoPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- Oficio Adjunto Estado 2 -->

                      <!-- Oficio Creado Estado 2 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 2 && slotProps.data.adjuntado == 2 && slotProps.data.vobo_ccp == 0 && slotProps.data.contestacion == 0 && slotProps.data.anexo == 0)"
                        label="Oficio creado" icon="fa-solid fa-file-code fa-beat" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado2 w-full"
                        v-tooltip.top="'Creaste un oficio desde correspondencia, modifica los datos si es necesario.'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,
                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,
                                slotProps.data.firmante,
                                slotProps.data.cargoFirmante,
                              );
                            },
                          },
                          {
                            label: 'Añadir vistos buenos y con copia para',
                            icon: 'pi pi-plus-circle',
                            command: () => {
                              openDialogVoBo(
                                'AnadirVB',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogMOficio(
                                'ModificarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Clonar oficio',
                            icon: 'pi pi-folder',
                            command: () => {
                              newStore.open();
                              newStore.state = slotProps.data;
                            },
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- Oficio Creado Estado 2 -->

                      <!-- Oficio Adjunto Contestado Estado 2 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 2 && slotProps.data.adjuntado == 1 && slotProps.data.vobo_ccp == 0 && slotProps.data.contestacion == 1 && slotProps.data.anexo == 0)"
                        label="Oficio contestado" icon="fa-solid fa-check-to-slot fa-bounce"
                        style="--fa-animation-duration: 5s; "
                        class="p-button-sm p-button-secondary splitRecepcionEstado8 w-full"
                        v-tooltip.top="'Contestaste un oficio adjunto, modifica los datos si es necesario.'" :model="[
                          {
                            label: 'Visualizar archivo adjunto',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio adjunto',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'ModificadoAdjuntoPDF',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Añadir vistos buenos y con copia para',
                            icon: 'pi pi-plus-circle',
                            command: () => {
                              openDialogVoBo(
                                'AnadirVB',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- Oficio Adjunto Contestado Estado 2 -->

                      <!-- Oficio Creado Contestado Estado 2 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 2 && slotProps.data.adjuntado == 2 && slotProps.data.vobo_ccp == 0 && slotProps.data.contestacion == 1 && slotProps.data.anexo == 0)"
                        label="Oficio contestado" icon="fa-solid fa-file-circle-check fa-bounce"
                        style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado8 w-full"
                        v-tooltip.top="'Contestaste un oficio creado desde correspondencia, modifica los datos si es necesario.'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,
                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,
                                slotProps.data.firmante,
                                slotProps.data.cargoFirmante,
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogMOficio(
                                'ModificarPDF',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Añadir vistos buenos y con copia para',
                            icon: 'pi pi-plus-circle',
                            command: () => {
                              openDialogVoBo(
                                'AnadirVB',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- Oficio Creado Contestado Estado 2 -->

                      <!-- Oficio Creado Estado 1 con Visto Bueno -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 1 && slotProps.data.vobo_ccp == 1 && slotProps.data.anexo == 0"
                        label="Visto bueno añadido" icon="fa-solid fa-question fa-beat"
                        style="--fa-animation-duration: 1.5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado1VB w-full"
                        v-tooltip.top="'Añadiste vistos buenos, ahora adjunta o crea un oficio.'" :model="[
                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Crear oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialog(
                                'CrearPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,

                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,

                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,

                                slotProps.data.cargoFirmante,
                                slotProps.data.firmante,
                              );
                            },
                          },
                          {
                            label: 'Adjuntar oficio',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'AdjuntarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- aa -->

                      <!-- Oficio Adjunto Estado 2 con Visto Bueno -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 2 && slotProps.data.adjuntado == 1 && slotProps.data.vobo_ccp == 1 && slotProps.data.anexo == 0"
                        label="Oficio adjunto con visto bueno" icon="fa-solid fa-paperclip fa-beat"
                        style="--fa-animation-duration: 5s; "
                        class="p-button-sm p-button-secondary splitGeneracionEstado2VB w-full"
                        v-tooltip.top="'Modifica algún dato si es necesario, antes de enviarlo a revisión con vistos buenos.'"
                        :model="[
                          {
                            label: 'Visualizar archivo adjunto',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio adjunto',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'ModificadoAdjuntoPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Enviar oficio adjunto a revisión',
                            icon: 'pi pi-send',
                            command: () => {
                              openDialogEnviarOficioVB(
                                'EnviarOficioVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- aa -->

                      <!-- Oficio Creado Estado 2 con Visto Bueno -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 2 && slotProps.data.adjuntado == 2 && slotProps.data.vobo_ccp == 1 && slotProps.data.anexo == 0"
                        label="Oficio creado con visto bueno" icon="fa-solid fa-file-code fa-beat"
                        style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado2VB w-full"
                        v-tooltip.top="'Modifica algún dato si es necesario, antes de enviarlo a revisión con vistos buenos.'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,

                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,
                                slotProps.data.firmante,
                                slotProps.data.cargoFirmante,
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogMOficio(
                                'ModificarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Enviar oficio creado a revisión',
                            icon: 'pi pi-send',
                            command: () => {
                              openDialogEnviarOficioVB(
                                'EnviarOficioVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- aa -->

                      <!-- Oficio Ajuntado pero solo con CCP -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 2 && slotProps.data.adjuntado == 1 && slotProps.data.vobo_ccp == 2 && slotProps.data.anexo == 0"
                        label="Oficio adjunto con C.C.P." icon="fa-solid fa-calendar-check fa-beat"
                        style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado2CCP w-full"
                        v-tooltip.top="'Añadiste personas con copia para, ahora adjunta o crea un oficio.'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,
                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,
                                slotProps.data.firmante,
                                slotProps.data.cargoFirmante,
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio adjunto',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'ModificadoAdjuntoPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- Oficio Ajuntado pero solo con CCP -->

                      <!-- Oficio Creado pero solo con CCP -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 2 && slotProps.data.adjuntado == 2 && slotProps.data.vobo_ccp == 2 && slotProps.data.anexo == 0"
                        label="Oficio creado con C.C.P." icon="fa-regular fa-calendar-check fa-beat"
                        style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado2CCP w-full"
                        v-tooltip.top="'Modifica algún dato si es necesario, antes de pasarlo a firmar'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,
                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,
                                slotProps.data.firmante,
                                slotProps.data.cargoFirmante,
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogMOficio(
                                'ModificarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- Oficio Creado pero solo con CCP -->

                      <!-- #########################################################SIN ANEXO################################################################ -->


                      <!-- #########################################################CON ANEXO################################################################ -->

                      <!-- Oficio Creado Estado 1 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 1 && slotProps.data.vobo_ccp == 0 && slotProps.data.anexo == 1)"
                        label="Elegir una opción-" icon="fa-solid fa-question fa-beat"
                        style="--fa-animation-duration: 1.5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado1 w-full"
                        v-tooltip.top="'La ficha ha sido creada, puedes añadir vistos buenos opcionalmente, después crear el oficio o adjuntarlo.'"
                        :model="[
                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Añadir vistos buenos y con copia para',
                            icon: 'pi pi-plus-circle',
                            command: () => {
                              openDialogVoBo(
                                'AnadirVB',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Crear oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialog(
                                'CrearPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,

                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,

                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,

                                slotProps.data.cargoFirmante,
                                slotProps.data.firmante,
                              );
                            },
                          },
                          {
                            label: 'Adjuntar oficio',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'AdjuntarPDF',
                                slotProps.data
                              );
                            },
                          },


                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- Oficio Creado Estado 1 -->

                      <!-- Oficio Creado con CCP Estado 1 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 1 && slotProps.data.vobo_ccp == 2 && slotProps.data.anexo == 1)"
                        label="C.C.P. añadido-" icon="fa-solid fa-question fa-beat"
                        style="--fa-animation-duration: 1.5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado1CCP w-full"
                        v-tooltip.top="'La ficha ha sido creada y se han añadido vistos buenos.'" :model="[
                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Crear oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialog(
                                'CrearPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,

                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,

                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,

                                slotProps.data.cargoFirmante,
                                slotProps.data.firmante,
                              );
                            },
                          },
                          {
                            label: 'Adjuntar oficio',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'AdjuntarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- Oficio Creado con CCP Estado 1 -->

                      <!-- Oficio Adjunto Estado 2 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 2 && slotProps.data.adjuntado == 1 && slotProps.data.vobo_ccp == 0 && slotProps.data.contestacion == 0 && slotProps.data.anexo == 1)"
                        label="Oficio adjunto-" icon="fa-solid fa-paperclip fa-beat"
                        style="--fa-animation-duration: 5s; "
                        class="p-button-sm p-button-secondary splitGeneracionEstado2 w-full"
                        v-tooltip.top="'Se adjunto un archivo, modificalo si es necesario.'" :model="[
                          {
                            label: 'Visualizar archivo adjunto',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Añadir vistos buenos y con copia para',
                            icon: 'pi pi-plus-circle',
                            command: () => {
                              openDialogVoBo(
                                'AnadirVB',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio adjunto',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'ModificadoAdjuntoPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- Oficio Adjunto Estado 2 -->

                      <!-- Oficio Creado Estado 2 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 2 && slotProps.data.adjuntado == 2 && slotProps.data.vobo_ccp == 0 && slotProps.data.contestacion == 0 && slotProps.data.anexo == 1)"
                        label="Oficio creado-" icon="fa-solid fa-file-code fa-beat" style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado2 w-full"
                        v-tooltip.top="'Creaste un oficio desde correspondencia, modifica los datos si es necesario.'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,
                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,
                                slotProps.data.firmante,
                                slotProps.data.cargoFirmante,
                              );
                            },
                          },
                          {
                            label: 'Añadir vistos buenos y con copia para',
                            icon: 'pi pi-plus-circle',
                            command: () => {
                              openDialogVoBo(
                                'AnadirVB',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogMOficio(
                                'ModificarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- Oficio Creado Estado 2 -->

                      <!-- Oficio Adjunto Contestado Estado 2 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 2 && slotProps.data.adjuntado == 1 && slotProps.data.vobo_ccp == 0 && slotProps.data.contestacion == 1 && slotProps.data.anexo == 1)"
                        label="Oficio contestado-" icon="fa-solid fa-check-to-slot fa-bounce"
                        style="--fa-animation-duration: 5s; "
                        class="p-button-sm p-button-secondary splitRecepcionEstado8 w-full"
                        v-tooltip.top="'Contestaste un oficio adjunto, modifica los datos si es necesario.'" :model="[
                          {
                            label: 'Visualizar archivo adjunto',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio adjunto',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'ModificadoAdjuntoPDF',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Añadir vistos buenos y con copia para',
                            icon: 'pi pi-plus-circle',
                            command: () => {
                              openDialogVoBo(
                                'AnadirVB',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- Oficio Adjunto Contestado Estado 2 -->

                      <!-- Oficio Creado Contestado Estado 2 -->
                      <SplitButtonVue
                        v-if="(slotProps.data.status == 2 && slotProps.data.adjuntado == 2 && slotProps.data.vobo_ccp == 0 && slotProps.data.contestacion == 1 && slotProps.data.anexo == 1)"
                        label="Oficio contestado-" icon="fa-solid fa-file-circle-check fa-bounce"
                        style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitRecepcionEstado8 w-full"
                        v-tooltip.top="'Contestaste un oficio creado desde correspondencia, modifica los datos si es necesario.'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,
                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,
                                slotProps.data.firmante,
                                slotProps.data.cargoFirmante,
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogMOficio(
                                'ModificarPDF',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Añadir vistos buenos y con copia para',
                            icon: 'pi pi-plus-circle',
                            command: () => {
                              openDialogVoBo(
                                'AnadirVB',
                                slotProps.data,
                              );
                            },
                          },
                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- Oficio Creado Contestado Estado 2 -->

                      <!-- Oficio Creado Estado 1 con Visto Bueno -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 1 && slotProps.data.vobo_ccp == 1 && slotProps.data.anexo == 1"
                        label="Visto bueno añadido-" icon="fa-solid fa-question fa-beat"
                        style="--fa-animation-duration: 1.5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado1VB w-full"
                        v-tooltip.top="'Añadiste vistos buenos, ahora adjunta o crea un oficio.'" :model="[
                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data,
                              );
                            },
                          },

                          {
                            label: 'Crear oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialog(
                                'CrearPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,

                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,

                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,

                                slotProps.data.cargoFirmante,
                                slotProps.data.firmante,
                              );
                            },
                          },
                          {
                            label: 'Adjuntar oficio',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'AdjuntarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- aa -->

                      <!-- Oficio Adjunto Estado 2 con Visto Bueno -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 2 && slotProps.data.adjuntado == 1 && slotProps.data.vobo_ccp == 1 && slotProps.data.anexo == 1"
                        label="Oficio adjunto con visto bueno-" icon="fa-solid fa-paperclip fa-beat"
                        style="--fa-animation-duration: 5s; "
                        class="p-button-sm p-button-secondary splitGeneracionEstado2VB w-full"
                        v-tooltip.top="'Modifica algún dato si es necesario, antes de enviarlo a revisión con vistos buenos.'"
                        :model="[
                          {
                            label: 'Visualizar archivo adjunto',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio adjunto',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'ModificadoAdjuntoPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Enviar oficio adjunto a revisión',
                            icon: 'pi pi-send',
                            command: () => {
                              openDialogEnviarOficioVB(
                                'EnviarOficioVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- aa -->

                      <!-- Oficio Creado Estado 2 con Visto Bueno -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 2 && slotProps.data.adjuntado == 2 && slotProps.data.vobo_ccp == 1 && slotProps.data.anexo == 1"
                        label="Oficio creado con visto bueno-" icon="fa-solid fa-file-code fa-beat"
                        style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado2VB w-full"
                        v-tooltip.top="'Modifica algún dato si es necesario, antes de enviarlo a revisión con vistos buenos.'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,

                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,
                                slotProps.data.firmante,
                                slotProps.data.cargoFirmante,
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogMOficio(
                                'ModificarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Enviar oficio creado a revisión',
                            icon: 'pi pi-send',
                            command: () => {
                              openDialogEnviarOficioVB(
                                'EnviarOficioVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- aa -->

                      <!-- Oficio Ajuntado pero solo con CCP -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 2 && slotProps.data.adjuntado == 1 && slotProps.data.vobo_ccp == 2 && slotProps.data.anexo == 1"
                        label="Oficio adjunto con C.C.P.-" icon="fa-solid fa-calendar-check fa-beat"
                        style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado2CCP w-full"
                        v-tooltip.top="'Añadiste personas con copia para, ahora adjunta o crea un oficio.'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,
                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,
                                slotProps.data.firmante,
                                slotProps.data.cargoFirmante,
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio adjunto',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'ModificadoAdjuntoPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- Oficio Ajuntado pero solo con CCP -->

                      <!-- Oficio Creado pero solo con CCP -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 2 && slotProps.data.adjuntado == 2 && slotProps.data.vobo_ccp == 2 && slotProps.data.anexo == 1"
                        label="Oficio creado con C.C.P.-" icon="fa-regular fa-calendar-check fa-beat"
                        style="--fa-animation-duration: 5s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado2CCP w-full"
                        v-tooltip.top="'Modifica algún dato si es necesario, antes de pasarlo a firmar'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio,

                                slotProps.data.destinatario,
                                slotProps.data.cargoDestinatario,
                                slotProps.data.oficinaDestinatario,
                                slotProps.data.atencionA,
                                slotProps.data.cargoAtencionA,
                                slotProps.data.firmante,
                                slotProps.data.cargoFirmante,
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogMOficio(
                                'ModificarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            separator: true
                          },

                          {
                            label: 'Pasar a firmar',
                            icon: 'pi pi-directions',
                            command: () => {
                              openDialogEnviarOficio(
                                'EnviarOficiosinVB',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },

                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- Oficio Creado pero solo con CCP -->

                      <!-- #########################################################CON ANEXO################################################################ -->

                    </template>
                  </ColumnVue>
                </DataTable>
              </div>

              <!-- Tabla de estatus -->
              <!-- <div class="barraEstados text-center">
                <div class="card">
                  <div class="grid">

                    <div class="col-2">
                      <i
                        v-badge="contadorOficiosNuevos"
                        class="pi pi-book p-overlay-badge tablaEstatus1 mx-2 mt-3"
                        style="font-size: 2rem"
                      />

                      <p class="fontBarraEstados mx-2 mt-1">Oficios totales</p>
                    </div>

                  </div>
                </div>
              </div> -->
              <!-- Tabla de estatus -->

            </TabPanelVue>
            <!-- Tabla de Creados -->

            <!-- Tabla de Oficios en Espera -->
            <TabPanelVue>
              <template #header>
                <div class="divTabs" @click="getFichasEspera">
                  <!-- Contador para oficios -->
                  <BadgeVue :value="contadorOficiosEspera" class="titulosPestanasContador">
                  </BadgeVue>
                  <!-- Contador para oficios -->
                  <i class="fa-solid fa-clock fa-bounce px-2"
                    style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
                  <span class="">Oficios en espera</span>
                </div>
              </template>

              <div class="card p-1">
                <DataTable :value="fichas" responsiveLayout="scroll" :lazy="true" :totalRecords="totalRecordsEspera"
                  @page="onPageEspera($event)" @filter="onFilterEspera($event)" v-model:filters="filtersEnviados"
                  stripedRows sortField="numeroOficio" :sortOrder="-1" :paginator="true" :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort dataKey="numeroOficio" class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-2">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <!-- <i class="pi pi-search" /> -->
                            <InputTextV v-model="filtersEnviados['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" autocomplete="off" name="table_search" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>

                    <InlineMessageVue class="msgTablas">
                      <i class="fa-solid fa-triangle-exclamation fa-beat px-2" style="--fa-animation-duration: 1.5s">
                      </i>
                      No se encontraron oficios en espera.
                    </InlineMessageVue>

                  </template>

                  <ColumnVue v-for="col of columnsAlt" :field="col.field" :header="col.header" :key="col.field"
                    :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>

                  <ColumnVue field="vistos_buenos" :sortable="true" :exportable="false" style="min-width: 12rem"
                    header="VistosBuenos" class="tablaOficiosData">
                    <template #body="slotProps">
                      <span v-if="slotProps.data.vistos_buenos === ''">
                        N/A
                      </span>
                      <span v-else>
                        <ButtonVue label="Ver Vistos buenos" icon="pi pi-eye" class="p-button-text"
                          @click="verVistosBuenos(slotProps.data)" />
                      </span>
                    </template>
                  </ColumnVue>

                  <ColumnVue :exportable="false" style="min-width: 8rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- Enviado Oficio Adjunto Estado 3 -->
                      <SplitButtonVue v-if="slotProps.data.status == 3 && slotProps.data.adjuntado == 1"
                        label="Enviado a visto bueno" icon="fa-solid fa-paper-plane fa-flip"
                        style="--fa-animation-duration: 10s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado3 w-full"
                        v-tooltip.top="'El oficio adjunto ha sido enviado y está siendo aprobado por los participantes'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Enviado Oficio Adjunto Estado 3 -->

                      <!-- Enviado Oficio Creado Estado 3 -->
                      <SplitButtonVue v-if="slotProps.data.status == 3 && slotProps.data.adjuntado == 2"
                        label="Enviado a visto bueno" icon="fa-regular fa-paper-plane fa-flip"
                        style="--fa-animation-duration: 10s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado3 w-full"
                        v-tooltip.top="'El oficio creado está siendo aprobado por los participantes'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Enviado Oficio Creado Estado 3 -->

                    </template>
                  </ColumnVue>
                </DataTable>
              </div>

            </TabPanelVue>
            <!-- Tabla de Oficios en Espera -->

            <!-- Tabla de Oficios con Observación -->
            <TabPanelVue>
              <template #header>
                <div class="divTabs" @click="getFichasObservacion">
                  <!-- Contador para oficios -->
                  <BadgeVue :value="contadorOficiosObservacion" class="titulosPestanasContador">
                  </BadgeVue>
                  <!-- Contador para oficios -->
                  <i class="fa-solid fa-triangle-exclamation fa-bounce px-2"
                    style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
                  <span>Oficios con observación</span>
                </div>
              </template>

              <div class="card p-1">
                <DataTable :value="fichas" responsiveLayout="scroll" :lazy="true"
                  :totalRecords="totalRecordsObservacion" @page="onPageObservacion($event)"
                  @filter="onFilterObservacion($event)" v-model:filters="filtersObservacion" stripedRows
                  sortField="numeroOficio" :sortOrder="-1" :paginator="true" :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort dataKey="numeroOficio" class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-2">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <!-- <i class="pi pi-search" /> -->
                            <InputTextV v-model="filtersObservacion['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" autocomplete="off" name="table_search" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>

                    <InlineMessageVue class="msgTablas">
                      <i class="fa-solid fa-triangle-exclamation fa-beat px-2" style="--fa-animation-duration: 1.5s">
                      </i>
                      No se encontraron oficios con observación.
                    </InlineMessageVue>

                  </template>

                  <ColumnVue v-for="col of columnsAlt" :field="col.field" :header="col.header" :key="col.field"
                    :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>

                  <ColumnVue field="vistos_buenos" :sortable="true" :exportable="false" style="min-width: 12rem"
                    header="VistosBuenos" class="tablaOficiosData">
                    <template #body="slotProps">
                      <span v-if="slotProps.data.vistos_buenos === ''">
                        N/A
                      </span>
                      <span v-else>
                        <ButtonVue label="Ver Vistos buenos" icon="pi pi-eye" class="p-button-text"
                          @click="verVistosBuenos(slotProps.data)" />
                      </span>
                    </template>
                  </ColumnVue>

                  <ColumnVue :exportable="false" tyle="min-width: 8rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- #########################################################SIN ANEXO################################################################ -->
                      <!-- Revision Oficio Adjunto Estado 4 -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 4 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 0"
                        label="Revisar oficio" icon="fa-solid fa-paperclip fa-beat-fade"
                        style="--fa-animation-duration: 1s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado4 w-full"
                        v-tooltip.top="'El oficio adjunto requiere de una revisión'" :model="[

                          {
                            label: 'Observaciones del oficio',
                            icon: 'pi pi-comment',
                            command: () => {
                              openMsgVB(
                                'NotaOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio adjunto',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'ModificadoAdjuntoPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Reenviar oficio creado',
                            icon: 'pi pi-send',
                            command: () => {
                              reenviarOficios(slotProps.data.idOficio);
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },


                        ]" />
                      <!-- Revision Oficio Adjunto Estado 4 -->

                      <!-- Revision Oficio Creado Estado 4 -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 4 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 0"
                        label="Revisar oficio" icon="fa-solid fa-file-circle-exclamation fa-beat-fade"
                        style="--fa-animation-duration: 1s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado4 w-full"
                        v-tooltip.top="'El oficio creado está siendo aprobado por los participantes'" :model="[

                          {
                            label: 'Observaciones del oficio',
                            icon: 'pi pi-comment',
                            command: () => {
                              openMsgVB(
                                'NotaOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogMOficio(
                                'ModificarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Reenviar oficio creado',
                            icon: 'pi pi-send',
                            command: () => {
                              reenviarOficios(slotProps.data.idOficio);
                            },
                          },

                          {
                            label: 'Añadir anexo',
                            icon: 'pi pi-folder',
                            command: () => {
                              openDialogAnexar(
                                'AnadirAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" />
                      <!-- Revision Oficio Creado Estado 4 -->
                      <!-- #########################################################SIN ANEXO################################################################ -->

                      <!-- #########################################################CON ANEXO################################################################ -->
                      <!-- Revision Oficio Adjunto Estado 4 -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 4 && slotProps.data.adjuntado == 1 && slotProps.data.anexo == 1"
                        label="Revisar oficio-" icon="fa-solid fa-paperclip fa-beat-fade"
                        style="--fa-animation-duration: 1s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado4 w-full"
                        v-tooltip.top="'El oficio adjunto requiere de una revisión'" :model="[

                          {
                            label: 'Observaciones del oficio',
                            icon: 'pi pi-comment',
                            command: () => {
                              openMsgVB(
                                'NotaOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio adjunto',
                            icon: 'pi pi-file-import',
                            command: () => {
                              openDialogMFicha(
                                'ModificadoAdjuntoPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Reenviar oficio creado',
                            icon: 'pi pi-send',
                            command: () => {
                              reenviarOficios(slotProps.data.idOficio);
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- Revision Oficio Adjunto Estado 4 -->

                      <!-- Revision Oficio Creado Estado 4 -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 4 && slotProps.data.adjuntado == 2 && slotProps.data.anexo == 1"
                        label="Revisar oficio-" icon="fa-solid fa-file-circle-exclamation fa-beat-fade"
                        style="--fa-animation-duration: 1s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado4 w-full"
                        v-tooltip.top="'El oficio creado está siendo aprobado por los participantes'" :model="[

                          {
                            label: 'Observaciones del oficio',
                            icon: 'pi pi-comment',
                            command: () => {
                              openMsgVB(
                                'NotaOficio',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Ver oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Modificar ficha',
                            icon: 'pi pi-file-edit',
                            command: () => {
                              openDialogMFicha(
                                'ModificarFicha',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Modificar oficio',
                            icon: 'pi pi-file-pdf',
                            command: () => {
                              openDialogMOficio(
                                'ModificarPDF',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Reenviar oficio creado',
                            icon: 'pi pi-send',
                            command: () => {
                              reenviarOficios(slotProps.data.idOficio);
                            },
                          },

                          {
                            label: 'Modificar anexo',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialogAnexarModificar(
                                'ModificarAnexos',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Descargar anexo',
                            icon: 'pi pi-download',
                            command: () => {
                              descargarAnexos(slotProps.data.idOficio)
                            },
                          },

                        ]" />
                      <!-- Revision Oficio Creado Estado 4 -->
                      <!-- #########################################################CON ANEXO################################################################ -->

                    </template>
                  </ColumnVue>
                </DataTable>

              </div>

            </TabPanelVue>
            <!-- Tabla de Oficios con Observación -->

            <!-- Tabla de Oficios para Firmar para Titulares -->
            <TabPanelVue v-if="esTitular">
              <template #header>
                <div class="divTabs" @click="getFichasFirma">
                  <!-- Contador para oficios -->
                  <BadgeVue :value="contadorOficiosFirmar" class="titulosPestanasContador">
                  </BadgeVue>
                  <!-- Contador para oficios -->
                  <i class="fa-solid fa-pencil fa-bounce px-2"
                    style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
                  <span>Firmar mis oficios nuevos</span>
                </div>
              </template>

              <div class="card p-1">
                <DataTable :lazy="true" :totalRecords="totalRecordsFirma" @page="onPageFirma($event)"
                  @filter="onFilterFirma($event)" v-model:filters="filtersFirma" :value="fichas"
                  v-model:selection="selectedFirmar" @selectionChange="handleSelectionChange" responsiveLayout="scroll"
                  sortField="numeroOficio" :sortOrder="-1" :paginator="true" :rows="10"
                  paginatorTemplate="CurrentPageReport PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort dataKey="numeroOficio" class="p-datatable-sm"
                  selectionMode="multiple" style="width: 100%">
                  <template #header>
                    <div class="grid">
                      <div class="col-6 p-1">
                        <div class="flex justify-content-start align-items-center">
                          <!-- {{ selectedFirmar.length }} -->
                          <ButtonVue :disabled="selectedFirmar.length == 0" type="button" @click="showModalSelected">
                            Firmar seleccionados
                          </ButtonVue>
                        </div>
                      </div>
                      <div class="col-6 p-2">
                        <div class="flex justify-content-end">
                          <span class="p-input-icon-left m-2">
                            <!-- <i class="pi pi-search" /> -->
                            <!-- Hack para que Chrome no aplique autofill -->
                            <input type="text" name="fake_field" autocomplete="username" tabindex="-1"
                              aria-hidden="true" style="display:none" />
                            <InputTextV v-model="filtersFirma['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" autocomplete="new-password" name="ignore_autofill_123" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template #empty>

                    <InlineMessageVue class="msgTablas">
                      <i class="fa-solid fa-triangle-exclamation fa-beat px-2" style="--fa-animation-duration: 1.5s">
                      </i>
                      No se encontraron oficios para firmar.
                    </InlineMessageVue>

                  </template>
                  <ColumnVue selectionMode="multiple" headerStyle="width: 3rem">
                    <template #body="slotProps">
                      <template v-if="slotProps.data.es_firmante">
                        <CheckboxVue v-model="selectedFirmar" :value="slotProps.data" />
                      </template>
                    </template>
                  </ColumnVue>


                  <ColumnVue v-for="col of columnsAlt" :field="col.field" :header="col.header" :key="col.field"
                    :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>

                  <ColumnVue field="vistos_buenos" :sortable="true" :exportable="false" style="min-width: 12rem"
                    header="VistosBuenos" class="tablaOficiosData">
                    <template #body="slotProps">
                      <span v-if="slotProps.data.vistos_buenos === ''">
                        N/A
                      </span>
                      <span v-else>
                        <ButtonVue label="Ver Vistos buenos" icon="pi pi-eye" class="p-button-text"
                          @click="verVistosBuenos(slotProps.data)" />
                      </span>
                    </template>
                  </ColumnVue>

                  <ColumnVue :exportable="false" style="min-width: 8rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- Firmar oficio Autor Adjunto Estado 5 -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 5 && slotProps.data.es_firmante && slotProps.data.adjuntado == 1"
                        label="Oficio aprobado" icon="fa-solid fa-signature fa-shake"
                        style="--fa-animation-duration: 3s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado5 w-full"
                        v-tooltip.top="'El oficio adjunto fue aprobado por los VB. y CCP. está listo para firmar'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Firmar oficio adjunto',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialog(
                                'AdjuntoFirmadoPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Regresar oficio',
                            icon: 'pi pi-replay',
                            command: () => {
                              openDialogRegresarOficio('RegresarOficio', slotProps.data)
                            }
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Firmar oficio Autor Adjunto Estado 5 -->

                      <!-- Firmar oficio Autor Creado Estado 5 -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 5 && slotProps.data.es_firmante && slotProps.data.adjuntado == 2"
                        label="Oficio aprobado" icon="fa-solid fa-file-contract fa-shake"
                        style="--fa-animation-duration: 3s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado5 w-full"
                        v-tooltip.top="'El oficio creado fue aprobado por los VB. y CCP. está listo para firmar'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Firmar oficio creado',
                            icon: 'pi pi-pencil',
                            command: () => {
                              openDialog(
                                'FirmarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.fechaCreacion,
                                slotProps.data.fechaOficio,
                                slotProps.data.dependenciaFirmante,
                                slotProps.data.subdependenciaFirmante,
                                slotProps.data.oficinaFirmante,
                                slotProps.data.numeroOficio
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Regresar oficio',
                            icon: 'pi pi-replay',
                            command: () => {
                              openDialogRegresarOficio('RegresarOficio', slotProps.data)
                            }
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Firmar oficio Autor Creado Estado 5 -->

                      <!-- Firmar oficio No es Autor Adjunto Estado 5 -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 5 && !slotProps.data.es_firmante && slotProps.data.adjuntado == 1"
                        label="Oficio aprobado" icon="fa-solid fa-signature fa-shake"
                        style="--fa-animation-duration: 3s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado5 w-full"
                        v-tooltip.top="'El oficio adjunto fue enviado para que lo firme el autor.'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Firmar oficio No es Autor Adjunto Estado 5 -->

                      <!-- Firmar oficio No es Autor Creado Estado 5 -->
                      <SplitButtonVue
                        v-if="slotProps.data.status == 5 && !slotProps.data.es_firmante && slotProps.data.adjuntado == 2"
                        label="Oficio Aprobado" icon="fa-solid fa-file-contract fa-shake"
                        style="--fa-animation-duration: 3s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado5 w-full"
                        v-tooltip.top="'El oficio creado fue enviado para que lo firme el autor.'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- Firmar oficio No es Autor Creado Estado 5 -->

                    </template>
                  </ColumnVue>
                </DataTable>

              </div>

            </TabPanelVue>
            <!-- Tabla de Oficios para Firmar para Titulares -->

            <!-- Tabla de Oficios para Firmar para NO Titulares -->
            <TabPanelVue v-if="noesTitular">
              <template #header>
                <div class="divTabs" @click="getFichasFirma">
                  <!-- Contador para oficios -->
                  <BadgeVue :value="contadorOficiosFirmar" class="titulosPestanasContador">
                  </BadgeVue>
                  <!-- Contador para oficios -->
                  <i class="fa-solid fa-file-circle-exclamation fa-bounce px-2"
                    style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
                  <span>Mis oficios en espera de firma</span>
                </div>
              </template>

              <div class="card p-1">
                <DataTable :value="fichas" responsiveLayout="scroll" :lazy="true" :totalRecords="totalRecordsFirma"
                  @page="onPageFirma($event)" @filter="onFilterFirma($event)" v-model:filters="filtersFirma" stripedRows
                  sortField="numeroOficio" :sortOrder="-1" :paginator="true" :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort dataKey="numeroOficio" class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-2">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <!-- <i class="pi pi-search" /> -->
                            <InputTextV v-model="filtersFirma['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" autocomplete="off" name="table_search" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>

                    <InlineMessageVue class="msgTablas">
                      <i class="fa-solid fa-triangle-exclamation fa-beat px-2" style="--fa-animation-duration: 1.5s">
                      </i>
                      No se encontraron oficios para firmar.
                    </InlineMessageVue>

                  </template>

                  <ColumnVue v-for="col of columnsAlt" :field="col.field" :header="col.header" :key="col.field"
                    :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>

                  <ColumnVue field="vistos_buenos" :sortable="true" :exportable="false" style="min-width: 12rem"
                    header="VistosBuenos" class="tablaOficiosData">
                    <template #body="slotProps">
                      <span v-if="slotProps.data.vistos_buenos === ''">
                        N/A
                      </span>
                      <span v-else>
                        <ButtonVue label="Ver Vistos buenos" icon="pi pi-eye" class="p-button-text"
                          @click="verVistosBuenos(slotProps.data)" />
                      </span>
                    </template>
                  </ColumnVue>

                  <ColumnVue :exportable="false" style="min-width: 8rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- <div v-if="slotProps.data.status == 5 && slotProps.data.es_firmante  && slotProps.data.adjuntado == 1"> -->
                      <SplitButtonVue label="Oficio aprobado" icon="fa-solid fa-file-powerpoint fa-shake"
                        style="--fa-animation-duration: 3s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado5 w-full"
                        v-tooltip.top="'El oficio adjunto fue aprobado por los VB. y CCP. está listo para firmar'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- </div> -->
                      <!-- <div v-else>Cosa</div> -->
                      <!-- Firmar oficio Autor Adjunto Estado 5 -->
                      <!-- <div>{{ slotProps.data.status == 5 && slotProps.data.es_firmante  && slotProps.data.adjuntado == 1 }}</div> -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 5 && slotProps.data.es_firmante  && slotProps.data.adjuntado == 1"
                        label="Oficio aprobado" icon="fa-solid fa-file-powerpoint fa-shake"
                        style="--fa-animation-duration: 3s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado5 w-full"
                        v-tooltip.top="'El oficio adjunto fue aprobado por los VB. y CCP. está listo para firmar'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" /> -->
                      <!-- Firmar oficio Autor Adjunto Estado 5 -->
                      <!-- <div>{{ slotProps.data.adjuntado }}</div>
                          <div>{{ slotProps.data.status == 5 && slotProps.data.adjuntado == 2 }}</div>
                          <div v-if="slotProps.data.status == 5 && slotProps.data.adjuntado == 2"> <SplitButtonVue 
                        label="Oficio aprobado" icon="fa-solid fa-file-powerpoint fa-shake"
                        style="--fa-animation-duration: 3s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado5 w-full"
                        v-tooltip.top="'El oficio creado fue aprobado por los VB. y CCP. está listo para firmar'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" /></div> -->
                      <!-- <div v-else>No oa</div> -->
                      <!-- Firmar oficio Autor Creado Estado 5 -->
                      <!-- <SplitButtonVue 
                        label="Oficio aprobado" icon="fa-solid fa-file-powerpoint fa-shake"
                        style="--fa-animation-duration: 3s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado5 w-full"
                        v-tooltip.top="'El oficio creado fue aprobado por los VB. y CCP. está listo para firmar'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" /> -->
                      <!-- Firmar oficio Autor Creado Estado 5 -->

                      <!-- Firmar oficio No es Autor Adjunto Estado 5 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 5 && slotProps.data.adjuntado == 1"
                        label="Oficio aprobado" icon="fa-solid fa-signature fa-shake" style="--fa-animation-duration: 3s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado5 w-full"
                        v-tooltip.top="'El oficio adjunto fue enviado para que lo firme el autor.'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" /> -->
                      <!-- Firmar oficio No es Autor Adjunto Estado 5 -->

                      <!-- Firmar oficio No es Autor Creado Estado 5 -->
                      <!-- <SplitButtonVue v-if="slotProps.data.status == 5 && slotProps.data.adjuntado == 2"
                        label="Oficio Aprobado" icon="fa-solid fa-file-contract fa-shake"
                        style="--fa-animation-duration: 3s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado5 w-full"
                        v-tooltip.top="'El oficio creado fue enviado para que lo firme el autor.'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },

                        ]" /> -->
                      <!-- Firmar oficio No es Autor Creado Estado 5 -->

                    </template>
                  </ColumnVue>
                </DataTable>

              </div>

            </TabPanelVue>
            <!-- Tabla de Oficios para Firmar para NO Titulares -->

            <!-- Tabla de Oficios Firmados -->
            <TabPanelVue v-if="esTitular">
              <template #header>
                <div class="divTabs" @click="getFichasFirmadas">
                  <!-- Contador para oficios -->
                  <BadgeVue :value="contadorOficiosFirmados" class="titulosPestanasContador">
                  </BadgeVue>
                  <!-- Contador para oficios -->
                  <i class="fa-solid fa-square-check fa-bounce px-2"
                    style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
                  <span>Oficios firmados</span>
                </div>
              </template>

              <div class="card p-1">
                <DataTable :value="fichas" responsiveLayout="scroll" :lazy="true" :totalRecords="totalRecordsFirmados"
                  @page="onPageFirmados($event)" @filter="onFilterFirmados($event)" v-model:filters="filtersFirmados"
                  stripedRows sortField="numeroOficio" :sortOrder="-1" :paginator="true" :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort dataKey="numeroOficio" class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-2">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <!-- <i class="pi pi-search" /> -->
                            <InputTextV v-model="filtersFirmados['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" autocomplete="off" name="table_search" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>

                    <InlineMessageVue class="msgTablas">
                      <i class="fa-solid fa-triangle-exclamation fa-beat px-2" style="--fa-animation-duration: 1.5s">
                      </i>
                      No se encontraron oficios firmados.
                    </InlineMessageVue>

                  </template>

                  <ColumnVue v-for="col of columnsAlt" :field="col.field" :header="col.header" :key="col.field"
                    :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>

                  <ColumnVue field="vistos_buenos" :sortable="true" :exportable="false" style="min-width: 12rem"
                    header="VistosBuenos" class="tablaOficiosData">
                    <template #body="slotProps">
                      <span v-if="slotProps.data.vistos_buenos === ''">
                        N/A
                      </span>
                      <span v-else>
                        <ButtonVue label="Ver Vistos buenos" icon="pi pi-eye" class="p-button-text"
                          @click="verVistosBuenos(slotProps.data)" />
                      </span>
                    </template>
                  </ColumnVue>

                  <ColumnVue :exportable="false" style="min-width: 8rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- Firmado Oficio Adjunto Estado 6 -->
                      <SplitButtonVue v-if="slotProps.data.status == 6 && slotProps.data.adjuntado == 1"
                        label="Oficio firmado" icon="fa-solid fa-check-to-slot fa-bounce"
                        style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado6 w-full"
                        v-tooltip.top="'El oficio adjunto ha sido firmado, ahora puede enviarse.'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Enviar oficio adjunto',
                            icon: 'pi pi-send',
                            command: () => {
                              openDialogMOficio(
                                'EnviarPDF',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Firmado Oficio Adjunto Estado 6 -->

                      <!-- Firmado Oficio Creado Estado 6 -->
                      <SplitButtonVue v-if="slotProps.data.status == 6 && slotProps.data.adjuntado == 2"
                        label="Oficio firmado" icon="fa-solid fa-file-circle-check fa-bounce"
                        style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado6 w-full"
                        v-tooltip.top="'El oficio creado ha sido firmado, ahora puede enviarse.'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Enviar oficio creado',
                            icon: 'pi pi-send',
                            command: () => {
                              openDialogMOficio(
                                'EnviarPDF',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Firmado Oficio Creado Estado 6 -->

                    </template>
                  </ColumnVue>
                </DataTable>

              </div>

            </TabPanelVue>
            <!-- Tabla de Oficios Firmados -->

            <!-- Tabla de Oficios Firmados -->
            <TabPanelVue v-if="noesTitular">
              <template #header>
                <div class="divTabs" @click="getFichasFirmadas">
                  <!-- Contador para oficios -->
                  <BadgeVue :value="contadorOficiosFirmados" class="titulosPestanasContador">
                  </BadgeVue>
                  <!-- Contador para oficios -->
                  <i class="fa-solid fa-square-check fa-bounce px-2"
                    style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
                  <span>Oficios ya firmados</span>
                </div>
              </template>

              <div class="card p-1">
                <DataTable :value="fichas" responsiveLayout="scroll" :lazy="true" :totalRecords="totalRecordsFirmados"
                  @page="onPageFirmados($event)" @filter="onFilterFirmados($event)" v-model:filters="filtersFirmados"
                  stripedRows sortField="numeroOficio" :sortOrder="-1" :paginator="true" :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort dataKey="numeroOficio" class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-2">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <!-- <i class="pi pi-search" /> -->
                            <InputTextV v-model="filtersFirmados['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" autocomplete="off" name="table_search" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>

                    <InlineMessageVue class="msgTablas">
                      <i class="fa-solid fa-triangle-exclamation fa-beat px-2" style="--fa-animation-duration: 1.5s">
                      </i>
                      No se encontraron oficios firmados.
                    </InlineMessageVue>

                  </template>

                  <ColumnVue v-for="col of columnsAlt" :field="col.field" :header="col.header" :key="col.field"
                    :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>

                  <ColumnVue field="vistos_buenos" :sortable="true" :exportable="false" style="min-width: 12rem"
                    header="VistosBuenos" class="tablaOficiosData">
                    <template #body="slotProps">
                      <span v-if="slotProps.data.vistos_buenos === ''">
                        N/A
                      </span>
                      <span v-else>
                        <ButtonVue label="Ver Vistos buenos" icon="pi pi-eye" class="p-button-text"
                          @click="verVistosBuenos(slotProps.data)" />
                      </span>
                    </template>
                  </ColumnVue>

                  <ColumnVue :exportable="false" style="min-width: 8rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- Firmado Oficio Adjunto Estado 6 -->
                      <SplitButtonVue v-if="slotProps.data.status == 6 && slotProps.data.adjuntado == 1"
                        label="Oficio firmado" icon="fa-solid fa-check-to-slot fa-bounce"
                        style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado6 w-full"
                        v-tooltip.top="'El oficio adjunto ha sido firmado, ahora puede enviarse.'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Enviar oficio adjunto',
                            icon: 'pi pi-send',
                            command: () => {
                              openDialogMOficio(
                                'EnviarPDF',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Firmado Oficio Adjunto Estado 6 -->

                      <!-- Firmado Oficio Creado Estado 6 -->
                      <SplitButtonVue v-if="slotProps.data.status == 6 && slotProps.data.adjuntado == 2"
                        label="Oficio firmado" icon="fa-solid fa-file-circle-check fa-bounce"
                        style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado6 w-full"
                        v-tooltip.top="'El oficio creado ha sido firmado, ahora puede enviarse.'" :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Enviar oficio creado',
                            icon: 'pi pi-send',
                            command: () => {
                              openDialogMOficio(
                                'EnviarPDF',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]" />
                      <!-- Firmado Oficio Creado Estado 6 -->

                    </template>
                  </ColumnVue>
                </DataTable>

              </div>

            </TabPanelVue>
            <!-- Tabla de Oficios Firmados -->

            <!-- Tabla de Oficios Enviados -->
            <TabPanelVue>
              <template #header>
                <div class="divTabs" @click="getFichasEnviadas">
                  <!-- Contador para oficios -->
                  <BadgeVue :value="contadorOficiosEnviados" class="titulosPestanasContador">
                  </BadgeVue>
                  <!-- Contador para oficios -->
                  <i class="fa-solid fa-paper-plane fa-bounce px-2"
                    style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
                  <span>Oficios enviados</span>
                </div>
              </template>

              <div class="card p-1">
                <DataTable :value="fichas" responsiveLayout="scroll" :lazy="true"
                  :totalRecords="totalRecordsEnviadosRecepcion" @page="onPageEnviadas($event)"
                  @filter="onFilterEnviadas($event)" v-model:filters="filtersEnviadosRecepcion" stripedRows
                  sortField="numeroOficio" :sortOrder="-1" :paginator="true" :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]" removableSort dataKey="numeroOficio" class="p-datatable-sm"
                  style="width: 100%">

                  <template #header>
                    <div class="grid">

                      <div class="col-12 p-2">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <!-- <i class="pi pi-search" /> -->
                            <InputTextV v-model="filtersEnviadosRecepcion['global'].value" placeholder="Buscar"
                              class="p-inputtext-sm" autocomplete="off" name="table_search" />
                          </span>
                        </div>
                      </div>

                    </div>

                  </template>

                  <template #empty>

                    <InlineMessageVue class="msgTablas">
                      <i class="fa-solid fa-triangle-exclamation fa-beat px-2" style="--fa-animation-duration: 1.5s">
                      </i>
                      No se encontraron oficios enviados.
                    </InlineMessageVue>

                  </template>

                  <ColumnVue v-for="col of columns" :field="col.field" :header="col.header" :key="col.field"
                    :sortable="true" :hidden="col.hidden" class="border-dashed border-300 tablaOficiosData">
                  </ColumnVue>

                  <ColumnVue field="vistos_buenos" :sortable="true" :exportable="false" style="min-width: 12rem"
                    header="VistosBuenos" class="tablaOficiosData">
                    <template #body="slotProps">
                      <span v-if="slotProps.data.vistos_buenos === ''">
                        N/A
                      </span>
                      <span v-else>
                        <ButtonVue label="Ver Vistos buenos" icon="pi pi-eye" class="p-button-text"
                          @click="verVistosBuenos(slotProps.data)" />
                      </span>
                    </template>
                  </ColumnVue>

                  <ColumnVue :exportable="false" style="min-width: 8rem" header="Opciones" class="tablaOficiosData">
                    <template #body="slotProps">

                      <!-- EnviadoR. Oficio Adjunto Estado 7 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 1"
                        label="Enviado a recepción" icon="fa-solid fa-paper-plane fa-flip"
                        style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado7 w-full"
                        v-tooltip.top="'El oficio adjunto fue enviado a recepción, ahora puedes visualizar tu acuse.'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])


                        ]" />
                      <!-- EnviadoR. Oficio Adjunto Estado 7 -->

                      <!-- EnviadoR. Oficio Creado Estado 7 -->
                      <SplitButtonVue v-if="slotProps.data.status == 7 && slotProps.data.adjuntado == 2"
                        label="Enviado a recepción" icon="fa-regular fa-paper-plane fa-flip"
                        style="--fa-animation-duration: 15s;"
                        class="p-button-sm p-button-secondary splitGeneracionEstado7 w-full"
                        v-tooltip.top="'El oficio creado fue enviado a recepción, ahora puedes visualizar tu acuse.'"
                        :model="[
                          {
                            label: 'Visualizar oficio',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },

                          {
                            label: 'Ver acuse del oficio',
                            icon: 'pi pi-verified',
                            command: () => {
                              openDialog(
                                'VisualizarAcuse',
                                slotProps.data.idOficio,
                                slotProps.data.id
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(
                                slotProps.data
                              );
                            },
                          },
                          {
                            separator: true
                          },
                          {
                            label: 'Cancelar oficio',
                            icon: 'pi pi-flag',
                            command: () => {
                              getCancelOficio(
                                slotProps.data
                              );
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])

                        ]" />
                      <!-- EnviadoR. Oficio Creado Estado 7 -->

                    </template>
                  </ColumnVue>
                </DataTable>
              </div>

            </TabPanelVue>
            <!-- Tabla de Oficios Enviados -->

          </TabViewVue>
        </div>
      </div>
      <!-- Tabs -->

    </div>
  </div>

  <DialogVue v-model:visible="visible" modal :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    pt:root:class="!border-0" pt:mask:class="backdrop-blur-sm">
    <template #container="{ closeCallback }">
      <div class="flex flex-column px-4 py-4 gap-6" style="border-radius: 12px; overflow-y: scroll; background:white">
        <span class="px-2">Adjunta los 2 archivos escribre la contraseña para firmar los oficios seleccionados.</span>
        <ul>
          <li v-for="element of selectedFirmar" :key="element.numeroOficio">
            {{ element.numeroOficio }} - {{ element.asunto }}
          </li>
        </ul>
        <div class="inline-flex flex-column ">
          <label class="font-semibold">Archivo .Key</label>
          <input class="form-control" type="file" id="formFile" accept=".key"
            @change="(event) => { handleFileUploadKey(event) }">
        </div>
        <div class="inline-flex flex-column ">
          <label class="font-semibold">Archivo .Cer</label>
          <input class="form-control" type="file" id="formFile1" accept=".cer"
            @change="(event) => { handleFileUploadCer(event) }">
        </div>
        <div class="inline-flex flex-column gap-2">
          <label class="font-semibold">Contraseña</label>
          <!-- Hack para que Chrome no aplique autofill -->
          <input type="text" style="display:none" autocomplete="off" />
          <PasswordVue :feedback="false" type="text" class="w-100" inputClass='w-100' autocomplete="off"
            name="no_autofill_pass" v-model="pass" @change="(event) => { handlePass(event) }" />
        </div>
        <div class="flex items-center gap-4 ">
          <ButtonVue label="Cancelar" @click="closeCallback" text
            class="!p-4 w-full !text-primary-50 !border !border-white/30 hover:!bg-white/10"></ButtonVue>
          <ButtonVue label="Enviar" :disabled="activarBoton" @click="getMultipleFirma" text
            class="!p-4 w-full !text-primary-50 !border !border-white/30 hover:!bg-white/10"></ButtonVue>
        </div>
      </div>
    </template>
  </DialogVue>

  <DialogVue v-model:visible="visibleBitacora" modal style="width: 60%;" pt:root:class="!border-0"
    pt:mask:class="backdrop-blur-sm">
    <template #container="{ closeCallback }">
      <div class="flex flex-column" style="background-color: white;position: relative;">
        <span @click="closeCallback"
          style="width: 100%; text-align:  right;font-size: 21px;top:8px; right: 18px; cursor:pointer; position: absolute;">X</span>

        <TabMenu class="m-0" v-model:activeIndex="tabVista" :model="items" />
        <div class="flex flex-row justify-content-center flex-wrap px-6  "
          style="height: 600px; border-radius: 12px; border-top-left-radius: 0; border-top-right-radius: 0;  overflow-y: scroll; background:white; position: relative">
          <h2 v-if="valueBitacora.length == 0" class="text-3xl text-gray-900">No hay movimientos</h2>
          <CardVue class="m-3" style="width:300px" v-for="(element, index) of valueBitacora"
            :key="element.usuario + index">
            <template #title>Movimiento #{{ index + 1 }}</template>
            <template #content>
              <ul>
                <li>Accion: <strong>{{ element.accion }}</strong></li>
                <li>Fecha: <strong>{{ element.fecha }}</strong></li>
                <li>Hora: <strong>{{ element.hora }}</strong></li>
                <li>Usuario: <strong>{{ element.usuario }}</strong></li>
              </ul>

            </template>
          </CardVue>
          <ButtonVue label="Cerrar" @click="closeCallback" text style="width:fit-content"
            class="!p-4 w-full !text-primary-50 !border !border-white/30 hover:!bg-white/10"></ButtonVue>

        </div>
      </div>
    </template>
  </DialogVue>



  <dialogEnviarOficioVB @valor="limpiarFilter" v-if="hasRole('EnviarOficioVB')" />
  <dialogEnviarOficio @valor="limpiarFilter" v-if="hasRole('EnviarOficiosinVB')" />

  <!-- Ficha General -->
  <dialogCrearFicha v-if="hasRole('CrearFicha')" />
  <dialogModificarFicha @valor="limpiarFilter" v-if="hasRole('ModificarFicha')" />
  <dialogNotaOficio v-if="hasRole('NotaOficio')" />
  <dialogAnadirVB @valor="limpiarFilter" v-if="hasRole('AnadirVB')" />
  <dialogAnadirAnexos @valor="limpiarFilter" v-if="hasRole('AnadirAnexos')" />
  <dialogModificarAnexos @valor="limpiarFilter" v-if="hasRole('ModificarAnexos')" />
  <!-- Ficha General -->

  <!-- Oficios Creados -->
  <dialogCrearPDF @valor="limpiarFilter" v-if="hasRole('CrearPDF')" />
  <dialogFirmarPDF @valor="limpiarFilter" v-if="hasRole('FirmarPDF')" />
  <dialogVisualizarPDF v-if="hasRole('VisualizarPDF')" />
  <dialogVisualizarAcuse v-if="hasRole('VisualizarAcuse')" />
  <dialogModificarPDF @valor="limpiarFilter" v-if="hasRole('ModificarPDF')" />
  <!--  <dialogReenviarPDF v-if="hasRole('ReenviarPDF')" /> -->
  <!-- Oficios Creados -->

  <!-- Oficios Adjunto -->
  <dialogAdjuntarPDF @valor="limpiarFilter" v-if="hasRole('AdjuntarPDF')" />
  <dialogFirmarAdjuntoPDF @valor="limpiarFilter" v-if="hasRole('AdjuntoFirmadoPDF')" />
  <dialogModificadoAdjuntoPDF @valor="limpiarFilter" v-if="hasRole('ModificadoAdjuntoPDF')" />
  <!-- Oficios Adjunto -->

  <!-- Oficios Firmados -->
  <dialogEnviarOficiosCreado @valor="limpiarFilter" v-if="hasRole('EnviarPDF')" />
  <!-- Oficios Firmados -->

  <!--Regresar oficio a creacion-->
  <dialogRegresarOficio @valor="limpiarFilter" :desde="'oficios'" v-if="hasRole('RegresarOficio')" />

  <DialogVue v-model:visible="displayModalVistosBuenos" :style="{ width: '450px' }" header="Lista de Vistos Buenos"
    :modal="true" class="p-fluid">
    <div v-if="selectedVistosBuenos.length > 0" class="card">
      <ul class="list-none p-0 m-0">
        <li v-for="(vb, index) in selectedVistosBuenos" :key="index"
          class="flex align-items-center py-3 px-2 border-top-1 surface-border hover:surface-hover">
          <div class="text-500 w-6 md:w-2 font-medium"><i class="pi pi-user text-primary mr-2"></i></div>
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ vb }}</div>
        </li>
      </ul>
    </div>
    <template #footer>
      <ButtonVue label="Cerrar" icon="pi pi-times" class="p-button-text" @click="displayModalVistosBuenos = false" />
    </template>
  </DialogVue>
</template>

<script>
import { ref, onMounted, defineAsyncComponent, watch } from 'vue';
import DataTable from "primevue/datatable";
import useOficiosList from "../composables/useOficiosCreacion";
import useOpenDialogs from "../composables/useOpenDialogs";
import dialogCrearFichaTabla from "../components/oficiosLibres/dialogCrearFicha";
import dialogClonar from "../components/oficiosLibres/dialogClonarFicha";
import dialogAyudaCreacionOficios from "../components/oficiosLibres/dialogAyudaCreacionOficios";
import dialogDescargarAnexo from "../composables/compDialogs/useDialogDescargarAnexo";
import useOficiosRecepcion from "../composables/useOficiosRecepcion";
import useDialogVByCPP from '@/modules/oficialia/composables/compDialogs/useDialogVByCCP';
import Swal from "sweetalert2";
import store from "@/store";
import { useRoute } from "vue-router";
import api from "@/api/laravelApi";
import { newStore } from '@/store/newStore';
import TabMenu from 'primevue/tabmenu';
import dialogRegresarOficio from '../components/oficiosLibres/dialogRegresarOficio.vue';

export default {
  data() {
    return {
      newStore,
    }
  },

  watch: {
    visibleBitacora(value) {
      if (value == false) {
        this.tabVista = 0
      }
    }
  },

  components: {
    DataTable, TabMenu,
    dialogCrearFichaTabla,
    dialogAyudaCreacionOficios,
    dialogClonar,

    //Ficha General
    dialogCrearFicha: defineAsyncComponent(() =>
      import("../components/oficiosLibres/dialogCrearFicha.vue")
    ),
    dialogModificarFicha: defineAsyncComponent(() =>
      import("../components/oficiosLibres/dialogModificarFicha.vue")
    ),
    dialogNotaOficio: defineAsyncComponent(() =>
      import("../components/oficiosLibres/dialogNotaOficio.vue")
    ),
    dialogAnadirVB: defineAsyncComponent(() =>
      import("../components/oficiosLibres/dialogAnadirVistosBuenos.vue")
    ),
    // dialogClonar: defineAsyncComponent(() =>
    //   import("../components/oficiosLibres/dialogClonar.vue")
    // ),
    //Ficha General

    //Oficios Creados
    dialogCrearPDF: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosCreados/dialogCrearPDF.vue")
    ),
    dialogFirmarPDF: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosCreados/dialogFirmarPDF.vue")
    ),
    dialogEnviarOficio: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosCreados/dialogEnviarCreadoF.vue")
    ),
    dialogVisualizarPDF: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosCreados/dialogVisualizarPDF.vue")
    ),
    dialogVisualizarAcuse: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosCreados/dialogVisualizarAcuse.vue")
    ),
    dialogModificarPDF: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosCreados/dialogModificarPDF.vue")
    ),

    /*  dialogReenviarPDF: defineAsyncComponent(() =>
       import("../components/oficiosLibres/oficiosCreados/dialogReenviarPDF.vue")
     ), */

    //Oficios Creados

    //Oficios Adjuntos
    dialogAdjuntarPDF: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosAdjuntos/dialogAdjuntarPDF.vue")
    ),
    dialogEnviarOficioVB: defineAsyncComponent(() =>
      import("../components/oficiosLibres/dialogEnviarOficioVB.vue")
    ),
    dialogFirmarAdjuntoPDF: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosAdjuntos/dialogFirmarAdjuntoPDF.vue")
    ),
    dialogModificadoAdjuntoPDF: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosAdjuntos/dialogAdjuntoModificadoPDF.vue")
    ),
    //Oficios Adjuntos

    //Oficios Firmados
    dialogEnviarOficiosCreado: defineAsyncComponent(() =>
      import("../components/oficiosLibres/oficiosCreados/dialogEnviarOficioCreado.vue")
    ),

    //Anexos
    dialogAnadirAnexos: defineAsyncComponent(() =>
      import("../components/oficiosLibres/dialogAnadirAnexos.vue")
    ),
    dialogModificarAnexos: defineAsyncComponent(() =>
      import("../components/oficiosLibres/dialogModificarAnexos.vue")
    ),
    dialogRegresarOficio
  },

  setup() {
    // const router = useRouter();
    const route = useRoute();
    let modalVal = ref(false)

    const selectedTab = ref(route.params.tab);
    let visible = ref(false);
    let activarBoton = ref(true)
    let pass = '';
    let Documentos = []

    let selectedFirmar = ref([]);

    const limpiarFilter = () => {
      filtersFirma.value = {
        ...filtersFirma.value,
        global: { value: '', matchMode: 'contains' }
      }
      filtersNuevos.value = {
        ...filtersNuevos.value,
        global: { value: '', matchMode: 'contains' }
      }
      filtersEnviados.value = {
        ...filtersEnviados.value,
        global: { value: '', matchMode: 'contains' }
      }
      filtersObservacion.value = {
        ...filtersObservacion.value,
        global: { value: '', matchMode: 'contains' }
      }
      filtersFirmados.value = {
        ...filtersFirmados.value,
        global: { value: '', matchMode: 'contains' }
      }
      filtersEnviadosRecepcion.value = {
        ...filtersEnviadosRecepcion.value,
        global: { value: '', matchMode: 'contains' }
      }

    }

    const handleSelectionChange = (e) => {
      const nuevosSeleccionados = e.value.filter(row => row.es_firmante);
      selectedFirmar.value = nuevosSeleccionados;
    };


    const handleFileUploadKey = async (event) => {
      Documentos[0] = event.target.files[0]

      if (Documentos[0] && Documentos[1] && pass !== '') {
        activarBoton.value = false
      } else {
        activarBoton.value = true
      }
    }

    const handleFileUploadCer = async (event) => {
      Documentos[1] = event.target.files[0]
      if (Documentos[0] && Documentos[1] && pass !== '') {
        activarBoton.value = false
      } else {
        activarBoton.value = true
      }
    }

    const handlePass = async (event) => {
      pass = event.target.value;
      if (Documentos[0] && Documentos[1] && pass !== '') {
        activarBoton.value = false
      } else {
        activarBoton.value = true
      }
    }

    const {
      downloadAnexo,
      openDialogAnexoDescargar,
    } = dialogDescargarAnexo();

    const {
      getVoBoyCcp,
    } = useDialogVByCPP();

    const {

      getFichasFirmadasR,
      getFichasRecepcionPendientes,
      getFichasRecepcionAtencionA,
      getFichasRecepcionTurnadosDestinatario,
      getFichasRecepcionTurnadosUsuario,

    } = useOficiosRecepcion();

    const {
      openDialog,
      openDialogEnviarOficio,
      openDialogEnviarOficioVB,
      openDialogVoBo,
      openDialogMFicha,
      openDialogMOficio,
      openMsgVB,
      openDialogAnexar,
      openDialogAnexarModificar,
      hasRole,
      toggleDialog,
      openDialogRegresarOficio,
    } = useOpenDialogs();

    const {
      columns,
      columnsAlt,
      filtersNuevos,
      filtersEnviados,
      filtersObservacion,
      filtersFirma,
      filtersFirmados,
      filtersEnviadosRecepcion,
      fichas,
      fichasFirmaC,
      fichasFirmadosC,
      getFichas,
      reenviarOficio,
      getFichasFirmaC,
      getFichasFirmadasC,


      contadorOficiosNuevos,
      contadorOficiosNuevosAlt,
      barraOficiosNuevos,

      contadorOficiosEspera,
      contadorOficiosEsperaAlt,
      barraOficiosEspera,

      contadorOficiosObservacion,
      contadorOficiosObservacionAlt,
      barraOficiosObservacion,

      contadorOficiosFirmar,
      contadorOficiosFirmarAlt,
      barraOficiosFirmar,

      contadorOficiosFirmar3,
      contadorOficiosFirmar3Alt,
      barraOficiosFirmar3,

      contadorOficiosFirmados,
      contadorOficiosFirmadosAlt,
      barraOficiosFirmados,

      contadorOficiosEnviados,
      contadorOficiosEnviadosAlt,
      barraOficiosEnviados,
      descargarAnexos,
      totalRecordsNuevos,
      totalRecordsEspera,
      totalRecordsObservacion,
      totalRecordsFirma,
      totalRecordsFirmados,
      totalRecordsEnviadosRecepcion
    } = useOficiosList();

    const messages = ref([]);
    const count = ref(0);
    const addMessages = () => {
      messages.value = [
        {
          icon: 'pi pi-search',
          severity: 'info',
          content: 'Dynamic Info Message',
          id: count.value++
        },
      ]
    };

    const reenviarOficios = async (idOficio) => {
      Swal.fire({
        title: 'Advertencia',
        text: '¿Reenviar oficio a revisión?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Enviar',
        confirmButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6'
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isDismissed) {
          new Swal({
            title: "Cargando...",
            text: "Reenviando oficio",
            allowOutsideClick: false,
          });
          Swal.showLoading();
          await reenviarOficio(idOficio);
          toggleDialog();
        } else if (result.isConfirmed) {
          Swal.close();
        }
      })
    };

    const fetchPaginated = async (val, page, per_page, filterRef, totalRecordRef) => {
      new Swal({ title: "Cargando...", text: "Actualizando...", allowOutsideClick: false }); Swal.showLoading();
      const filtro = filterRef.value['global']?.value || '';
      const res = await getFichas({ val, page, per_page, filtro });
      if (res.ok && res.pagination) totalRecordRef.value = res.pagination.total;
      else if (!res.ok) Swal.close();

      if (res.ok) Swal.close();
      return res;
    };

    const getFichasCreacion = async () => {
      localStorage.setItem("tab", 1);
      await fetchPaginated(1, 1, 10, filtersNuevos, totalRecordsNuevos);
    };
    const onPageNuevos = async (event) => { await fetchPaginated(1, event.page + 1, event.rows, filtersNuevos, totalRecordsNuevos); };
    const onFilterNuevos = async (event) => { await fetchPaginated(1, 1, event.rows, filtersNuevos, totalRecordsNuevos); };

    const getFichasEspera = async () => {
      localStorage.setItem("tab", 2);
      await fetchPaginated(2, 1, 10, filtersEnviados, totalRecordsEspera);
    };
    const onPageEspera = async (event) => { await fetchPaginated(2, event.page + 1, event.rows, filtersEnviados, totalRecordsEspera); };
    const onFilterEspera = async (event) => { await fetchPaginated(2, 1, event.rows, filtersEnviados, totalRecordsEspera); };

    const getFichasObservacion = async () => {
      localStorage.setItem("tab", 3);
      await fetchPaginated(3, 1, 10, filtersObservacion, totalRecordsObservacion);
    };
    const onPageObservacion = async (event) => { await fetchPaginated(3, event.page + 1, event.rows, filtersObservacion, totalRecordsObservacion); };
    const onFilterObservacion = async (event) => { await fetchPaginated(3, 1, event.rows, filtersObservacion, totalRecordsObservacion); };

    const getFichasFirma = async () => {
      localStorage.setItem("tab", 4);
      await fetchPaginated(4, 1, 10, filtersFirma, totalRecordsFirma);
    };
    const onPageFirma = async (event) => { await fetchPaginated(4, event.page + 1, event.rows, filtersFirma, totalRecordsFirma); };
    const onFilterFirma = async (event) => { await fetchPaginated(4, 1, event.rows, filtersFirma, totalRecordsFirma); };

    const getFichasFirmadas = async () => {
      localStorage.setItem("tab", 5);
      await fetchPaginated(5, 1, 10, filtersFirmados, totalRecordsFirmados);
    };
    const onPageFirmados = async (event) => { await fetchPaginated(5, event.page + 1, event.rows, filtersFirmados, totalRecordsFirmados); };
    const onFilterFirmados = async (event) => { await fetchPaginated(5, 1, event.rows, filtersFirmados, totalRecordsFirmados); };

    const getFichasEnviadas = async () => {
      localStorage.setItem("tab", 6);
      await fetchPaginated(6, 1, 10, filtersEnviadosRecepcion, totalRecordsEnviadosRecepcion);
    };
    const onPageEnviadas = async (event) => { await fetchPaginated(6, event.page + 1, event.rows, filtersEnviadosRecepcion, totalRecordsEnviadosRecepcion); };
    const onFilterEnviadas = async (event) => { await fetchPaginated(6, 1, event.rows, filtersEnviadosRecepcion, totalRecordsEnviadosRecepcion); };

    // ─── Watchers con debounce para búsqueda por teclado en cada tab ───────────
    let _searchTimers = {};
    const makeSearchWatcher = (filterRef, val, totalRef) => {
      watch(
        () => filterRef.value['global']?.value,
        () => {
          clearTimeout(_searchTimers[val]);
          _searchTimers[val] = setTimeout(() => {
            fetchPaginated(val, 1, 10, filterRef, totalRef);
          }, 500);
        }
      );
    };


    // Se registran los watchers para los 6 tabs de búsqueda
    makeSearchWatcher(filtersNuevos, 1, totalRecordsNuevos);
    makeSearchWatcher(filtersEnviados, 2, totalRecordsEspera);
    makeSearchWatcher(filtersObservacion, 3, totalRecordsObservacion);
    makeSearchWatcher(filtersFirma, 4, totalRecordsFirma);
    makeSearchWatcher(filtersFirmados, 5, totalRecordsFirmados);
    makeSearchWatcher(filtersEnviadosRecepcion, 6, totalRecordsEnviadosRecepcion);
    // ────────────────────────────────────────────────────────────────────────────

    //checar si es titular
    const esTitular = ref();
    const noesTitular = ref();

    const validarTitular = async () => {
      if (store.state.auth.user.titular == 1) {
        esTitular.value = true;
        noesTitular.value = false;
      } else {
        esTitular.value = false;
        noesTitular.value = true;
      }
    }

    const valArray = [
      { value: 2, function: getFichasCreacion },
      { value: 3, function: getFichasEspera },
      { value: 4, function: getFichasObservacion },
      { value: 5, function: getFichasFirma },
      { value: 6, function: getFichasFirmadas },
      { value: 7, function: getFichasEnviadas },
    ]
    const getCancelOficio = async (props) => {
      let valueStatus = props.status
      Swal.fire({
        title: "¿Estas seguro de cancelar oficio?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#80245f",
        cancelButtonColor: "#6d807f",
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          const body = {
            idOficio: props.idOficio
          }
          new Swal({
            title: "Cargando...",
            text: "Cancelando Oficio",
            allowOutsideClick: false,
          });
          Swal.showLoading();
          api.post(`oficios/cancelar`, body)
            .then(async (result) => {
              const { data } = result;

              await validarTitular();
              const functionGet = valArray.find((item) => item.value === valueStatus).function;
              await functionGet();
              await getAll()
              limpiarFilter()

              Swal.fire({
                title: "Oficio cancelado!",
                icon: "success",
                text: data.message,
                confirmButtonColor: "#80245f",
                confirmButtonText: "Continuar",
              })
            }).catch((error) => {
              Swal.fire({
                title: "Hubo un error!",
                text: JSON.parse(error.request.response).message,
                icon: "error"
              });

            });
        }
      });
    }

    const visibleBitacora = ref(false);
    const valueBitacora = ref([]);
    const saveOficio = ref('');
    const tabVista = ref(0);

    const toggleBitacora = async (data, tab = 1) => {
      Swal.showLoading();
      Swal.isLoading()
      visibleBitacora.value = true;
      saveOficio.value = { idOficio: data.idOficio }
      await api.get(`bitacora/${data.idOficio}/${tab}`)
        .then((response) => {
          valueBitacora.value = response.data.data.reverse();
          Swal.close()
        })
        .catch((error) => {
          Swal.close()
          // console.log(error)
          new Swal({
            title: "Error",
            text: error,
            allowOutsideClick: false,
          });
        })
    }
    const items = ref([
      {
        label: 'Movimientos de oficio',
        icon: 'pi pi-list',
        command: () => {
          toggleBitacora(saveOficio.value, 1)
        }
      },
      {
        label: 'Vistas de oficio',
        icon: 'pi pi-inbox',
        command: () => {
          toggleBitacora(saveOficio.value, 2)
        }
      },
    ]);

    const getAll = async () => {
      await api.get('oficios/cantidadOficios').
        then((response) => {
          const dataNum = response.data.data
          localStorage.setItem('cantidadOficios', JSON.stringify(dataNum));

          if (localStorage.getItem('cantidadOficios') !== null) {
            const data = JSON.parse(localStorage.getItem('cantidadOficios'));
            contadorOficiosNuevos.value = data.oficios_nuevos;
            contadorOficiosEspera.value = data.oficios_espera;
            contadorOficiosObservacion.value = data.oficios_observacion;
            contadorOficiosFirmar.value = data.oficios_firmar;
            contadorOficiosFirmados.value = data.oficios_firmados;
            contadorOficiosEnviados.value = data.oficios_enviados;

            totalRecordsNuevos.value = data.oficios_nuevos;
            totalRecordsEspera.value = data.oficios_espera;
            totalRecordsObservacion.value = data.oficios_observacion;
            totalRecordsFirma.value = data.oficios_firmar;
            totalRecordsFirmados.value = data.oficios_firmados;
            totalRecordsEnviadosRecepcion.value = data.oficios_enviados;
          }
        }
        ).catch(err => {
          console.log(err)
        })
    }

    onMounted(async () => {
      new Swal({
        title: "Cargando...",
        text: "Actualizando información del directorio de creación de oficios.",
        allowOutsideClick: false,
      });

      Swal.showLoading();
      const location = window.location.hash.split("/");
      const val = parseInt(location[location.length - 1]) + 1

      await validarTitular();
      await getAll();
      //No quitar ningun Swal... Sino se muere xd
      new Swal({
        title: "Cargando...",
        text: "Actualizando información del directorio de creación de oficios.",
        allowOutsideClick: false,
      });

      Swal.showLoading();
      const { ok, pagination } = await getFichas(val);
      localStorage.setItem("tab", val)
      if (!ok) Swal.close();
      else {
        if (val === 1 && pagination) totalRecordsNuevos.value = pagination.total;
        else if (val === 2 && pagination) totalRecordsEspera.value = pagination.total;
        else if (val === 3 && pagination) totalRecordsObservacion.value = pagination.total;
        else if (val === 4 && pagination) totalRecordsFirma.value = pagination.total;
        else if (val === 5 && pagination) totalRecordsFirmados.value = pagination.total;
        else if (val === 6 && pagination) totalRecordsEnviadosRecepcion.value = pagination.total;
        await Swal.close();
      }

      window.addEventListener("cantidadOficiosChanged", getAll);
      // await Swal.close()
    });

    const formData = new FormData();
    const getMultipleFirma = async () => {
      Swal.showLoading()
      const arrayKeyFiles = ['key', 'cer']
      formData.append('clave_fiel', pass);
      Documentos.forEach(function (value, index) {
        formData.append(arrayKeyFiles[index], value)
      })

      selectedFirmar.value
        .filter(element => element.es_firmante === true)
        .forEach(element => {
          formData.append(`idOficio[]`, element.idOficio);
        });

      let config = {
        headers: {
          'content-type': 'multipart/form-data'
        },
      }

      api.post(`/oficios/firmarOficios`, formData, config)
        .then(async (response) => {
          // console.log(response);

          let textS = '', textE = '', textW = '';
          // response.data.forEach((element) => {
          let lengthS = response.data.filter(sub => sub.status == 'success')
          let lengthW = response.data.filter(sub => sub.status == 'info')
          let lengthE = response.data.filter(sub => sub.status == 'error')
          // })

          if (lengthS.length !== 0) {

            textS = `<p style='color:green'>Elementos Firmados</p><ul>`;
            lengthS.forEach((element) => {
              textS += `<li>${element.message}</li>`;
            });
            textS += `</ul>`
          }
          if (lengthW.length !== 0) {
            textW = `<p style='color:yellow'>Elementos con Alerta</p><ul>`;
            lengthW.forEach((element) => {
              textW += `<li>${element.message}</li>`;
            });
            textW += `</ul>`
          }
          if (lengthE.length !== 0) {
            textE = `<p style='color:red'>Elementos con Errores</p><ul>`;
            lengthE.forEach((element) => {
              textE += `<li>${element.message}</li>`;
            });
            textE += `</ul>`
          }
          Swal.fire({
            title: "Estatus de Oficios ",
            html: `
      ${textS}
      ${textW}
      ${textE}
    `,
            showCancelButton: false,
            confirmButtonText: 'Aceptar'
          })
          Documentos = []
          activarBoton.value = true;
          visible.value = false
          pass = ''
          selectedFirmar.value = []
          Swal.hideLoading()
          await getFichasFirmaC();
          await getFichasFirmadasC();
        })
        .catch(error => {
          // Swal.close()
          const { data } = error.response;

          const cerError = data?.message?.cer?.[0];
          const keyError = data?.message?.key?.[0];

          let errors = [];

          if (cerError) errors.push(cerError);
          if (keyError) errors.push(keyError);

          const htmlErrors = errors.length > 0
            ? `<ul>${errors.map(e => `<li>${e}</li>`).join('')}</ul>`
            : `<p>${data.message}</p>`;

          Swal.fire({
            title: "Error",
            html: htmlErrors,
            icon: "error",
            confirmButtonText: "Aceptar",
          });
        })
    }

    const showModalSelected = () => {
      selectedFirmar.value = selectedFirmar.value.filter((item) => item.es_firmante);
      if (selectedFirmar.value.length > 0) {
        visible.value = true;
        // console.log(selectedFirmar.value.length)
      } else {
        Swal.fire({
          title: "Error",
          text: "El usuario no es Firmante del oficio seleccionado.",
          icon: "error",
          confirmButtonText: "Aceptar",
          timer: 1500,
        });
      }
    };

    // Vistos Buenos Modal Logic
    const displayModalVistosBuenos = ref(false);
    const selectedVistosBuenos = ref([]);

    const verVistosBuenos = (data) => {
      if (data && data.vistos_buenos) {
        // Split by comma and trim whitespace
        selectedVistosBuenos.value = data.vistos_buenos.split(',').map(item => item.trim()).filter(item => item);
        displayModalVistosBuenos.value = true;
      } else {
        selectedVistosBuenos.value = [];
        Swal.fire({
          icon: 'info',
          title: 'Sin vistos buenos',
          text: 'Este oficio no tiene vistos buenos asignados.',
          timer: 1500,
          showConfirmButton: false
        });
      }
    };

    return {
      modalVal, tabVista, items, limpiarFilter,
      visibleBitacora,
      toggleBitacora,
      valueBitacora,

      columns,
      columnsAlt,
      filtersNuevos,
      filtersEnviados,
      filtersObservacion,
      filtersFirmados,
      filtersFirma,
      filtersEnviadosRecepcion,
      addMessages,
      messages,
      hasRole,
      openDialog,
      openDialogEnviarOficio,
      openDialogEnviarOficioVB,
      openDialogMFicha,
      openDialogMOficio,
      openDialogVoBo,
      openMsgVB,
      getFichasFirma,
      onPageFirma,
      onFilterFirma,
      getFichasFirmadas,
      onPageFirmados,
      onFilterFirmados,
      getFichasEnviadas,
      onPageEnviadas,
      onFilterEnviadas,
      getFichasCreacion,
      onPageNuevos,
      onFilterNuevos,
      getFichasEspera,
      onPageEspera,
      onFilterEspera,
      getFichasObservacion,
      onPageObservacion,
      onFilterObservacion,
      fichas,
      fichasFirmaC,
      fichasFirmadosC,
      dialogCrearFichaTabla,
      dialogAyudaCreacionOficios,
      dialogClonar,
      totalRecordsNuevos,
      totalRecordsEspera,
      totalRecordsObservacion,
      totalRecordsFirma,
      totalRecordsFirmados,
      totalRecordsEnviadosRecepcion,

      reenviarOficios,
      esTitular,
      noesTitular,
      validarTitular,
      openDialogAnexar,
      openDialogAnexarModificar,
      openDialogAnexoDescargar,
      downloadAnexo,

      barraOficiosNuevos,
      contadorOficiosNuevos,
      contadorOficiosNuevosAlt,

      contadorOficiosEspera,
      contadorOficiosEsperaAlt,
      barraOficiosEspera,

      contadorOficiosObservacion,
      contadorOficiosObservacionAlt,
      barraOficiosObservacion,

      contadorOficiosFirmar,
      contadorOficiosFirmarAlt,
      barraOficiosFirmar,

      contadorOficiosFirmar3,
      contadorOficiosFirmar3Alt,
      barraOficiosFirmar3,

      contadorOficiosFirmados,
      contadorOficiosFirmadosAlt,
      barraOficiosFirmados,

      contadorOficiosEnviados,
      contadorOficiosEnviadosAlt,
      barraOficiosEnviados,

      getFichasFirmadasR,
      getFichasRecepcionPendientes,
      getFichasRecepcionAtencionA,
      getFichasRecepcionTurnadosDestinatario,
      getFichasRecepcionTurnadosUsuario,

      getVoBoyCcp,

      selectedTab,

      getCancelOficio,

      selectedFirmar,
      visible,
      handleFileUploadKey,
      handleFileUploadCer,
      handlePass,
      getMultipleFirma,
      handleSelectionChange,
      showModalSelected,


      openDialogRegresarOficio,
      dialogRegresarOficio,
      descargarAnexos,

      // Vistos Buenos
      displayModalVistosBuenos,
      selectedVistosBuenos,
      verVistosBuenos,
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep(.tablaEstatus1) {

  .p-overlay-badge {
    background-color: gray !important;
  }

  .p-badge {
    background-color: gray !important;
  }
}

::v-deep(.titulosPestanasContador) {
  font-size: 9px;
  background-color: rgb(18, 95, 168);
  // background-color: #bec3c9;
}


::v-deep(.msgTablas) {
  font-size: 10px;
  color: #3d1ada;
  background-color: #e3e3e3;

  .p-inline-message-icon {
    display: none;
  }
}

.modalBackground {
  background-color: #f0f0f0;
}

.modalTitle {
  background-color: white;
}

.gobcolor1 {
  color: #ffff;
  background-color: #4a001f;
}

.gobcolor1:hover {
  color: #ffff;
  background-color: #80245f;
}

::v-deep(.primerPasoOficio) {
  color: red;
  background-color: red;

  .p-splitbutton {
    color: red;
    background-color: red;
  }
}

.primerPasoOficio {
  color: red;
  background-color: red;
}

::v-deep(.botonGobColor:hover) {
  background-color: #80245f;
  border-color: #80245f;
  transition: ease 1s;

  .p-button-icon {
    color: rgb(255, 255, 255);
  }

  .p-button-label {
    font-size: 15px;
  }
}

::v-deep(.botonAyuda) {
  .p-button-icon {
    font-size: 25px;
    transition: ease 1s;
  }
}

::v-deep(.botonAyuda:hover) {
  .p-button-icon {
    font-size: 25px;
    color: rgb(77, 77, 77);
    transition: ease 1s;
  }
}

//Split Button para los Estados Responsivos

@media only screen and (max-width: 600px) {

  .tablaTitle {
    font-size: 15px;
    transition: ease 1s;
  }



  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 15px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 15px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 10px;
    transition: ease 1s;

    .p-column-title {
      font-size: 12px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 10.5px;
      transition: ease 1s;
    }
  }


  ::v-deep(.botonGobColorFicha) {
    background-color: #4a001f;
    // background-color: #8d949e;
    border-color: #4a001f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 13px;
    }
  }

  ::v-deep(.botonGobColorFicha:hover) {
    background-color: #80245f;
    // background-color: #8d949e;
    border-color: #80245f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 13px;
    }
  }

  ::v-deep(.splitGeneracionEstado1) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #333b3b !important;
      border-color: #333b3b !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado1CCP) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #2a4645 !important;
      border-color: #2a4645 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1CCP:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #172d2c !important;
      border-color: #172d2c !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado1VB) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #474747 !important;
      border-color: #474747 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1VB:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #232323 !important;
      border-color: #232323 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7F43DE !important;
      border-color: #7F43DE !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #3f00a3 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2VB) {
    .p-component {
      font-size: 8px !important;
      height: 55px !important;
      max-height: 55px !important;

      background-color: #491e8e !important;
      border-color: #491e8e !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2VB:hover) {
    .p-component {
      font-size: 8px !important;
      height: 55px !important;
      max-height: 55px !important;

      background-color: #220e42 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2CCP) {
    .p-component {
      font-size: 8px !important;
      height: 55px !important;
      max-height: 55px !important;

      background-color: #644597 !important;
      border-color: #644597 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2CCP:hover) {
    .p-component {
      font-size: 8px !important;
      height: 55px !important;
      max-height: 55px !important;

      background-color: #403551 !important;
      border-color: #403551 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado3) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #374BDB !important;
      border-color: #374BDB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado3:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #090996 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #BA2D20 !important;
      border-color: #BA2D20 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #741d15 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4VB) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #751b13 !important;
      border-color: #751b13 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4VB:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4a100b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado5) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #41A1DB !important;
      border-color: #41A1DB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado5:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #002e7e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado6) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #37DBC7 !important;
      border-color: #37DBC7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado6:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #096f94 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado7) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #42DB77 !important;
      border-color: #42DB77 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado7:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #007466 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

}

@media only screen and (min-width: 600px) {

  .tablaTitle {
    font-size: 18px;
    transition: ease 1s;
  }


  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 18px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 18px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 12px;
    transition: ease 1s;

    .p-column-title {
      font-size: 13px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 11px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonGobColorFicha) {
    background-color: #4a001f;
    // background-color: #8d949e;
    border-color: #4a001f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 13px;
    }
  }

  ::v-deep(.botonGobColorFicha:hover) {
    background-color: #80245f;
    // background-color: #8d949e;
    border-color: #80245f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 15px;
    }
  }

  ::v-deep(.splitGeneracionEstado1) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #333b3b !important;
      border-color: #333b3b !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado1CCP) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #2a4645 !important;
      border-color: #2a4645 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1CCP:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #172d2c !important;
      border-color: #172d2c !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado1VB) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #474747 !important;
      border-color: #474747 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1VB:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #232323 !important;
      border-color: #232323 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7F43DE !important;
      border-color: #7F43DE !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #3f00a3 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2VB) {
    .p-component {
      font-size: 8px !important;
      height: 55px !important;
      max-height: 55px !important;

      background-color: #491e8e !important;
      border-color: #491e8e !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2VB:hover) {
    .p-component {
      font-size: 8px !important;
      height: 55px !important;
      max-height: 55px !important;

      background-color: #220e42 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2CCP) {
    .p-component {
      font-size: 8px !important;
      height: 55px !important;
      max-height: 55px !important;

      background-color: #644597 !important;
      border-color: #644597 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2CCP:hover) {
    .p-component {
      font-size: 8px !important;
      height: 55px !important;
      max-height: 55px !important;

      background-color: #403551 !important;
      border-color: #403551 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado3) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #374BDB !important;
      border-color: #374BDB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado3:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #090996 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #BA2D20 !important;
      border-color: #BA2D20 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #741d15 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4VB) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #751b13 !important;
      border-color: #751b13 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4VB:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4a100b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado5) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #41A1DB !important;
      border-color: #41A1DB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado5:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #002e7e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado6) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #37DBC7 !important;
      border-color: #37DBC7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado6:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #096f94 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado7) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #42DB77 !important;
      border-color: #42DB77 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado7:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #007466 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

}

@media only screen and (min-width: 768px) {

  .tablaTitle {
    font-size: 14px;
    transition: ease 1s;
  }



  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 20px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 20px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 12px;
    transition: ease 1s;

    .p-column-title {
      font-size: 13px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 12px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonGobColorFicha) {
    background-color: #4a001f;
    // background-color: #8d949e;
    border-color: #4a001f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 13px;
    }
  }

  ::v-deep(.botonGobColorFicha:hover) {
    background-color: #80245f;
    // background-color: #8d949e;
    border-color: #80245f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 15px;
    }
  }

  ::v-deep(.splitGeneracionEstado1) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #333b3b !important;
      border-color: #333b3b !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado1CCP) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #2a4645 !important;
      border-color: #2a4645 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1CCP:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #172d2c !important;
      border-color: #172d2c !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado1VB) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #474747 !important;
      border-color: #474747 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1VB:hover) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #232323 !important;
      border-color: #232323 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7F43DE !important;
      border-color: #7F43DE !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #3f00a3 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2VB) {
    .p-component {
      font-size: 10px !important;
      height: 65px !important;
      max-height: 65px !important;

      background-color: #491e8e !important;
      border-color: #491e8e !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2VB:hover) {
    .p-component {
      font-size: 10px !important;
      height: 65px !important;
      max-height: 65px !important;

      background-color: #220e42 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2CCP) {
    .p-component {
      font-size: 10px !important;
      height: 65px !important;
      max-height: 65px !important;

      background-color: #644597 !important;
      border-color: #644597 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2CCP:hover) {
    .p-component {
      font-size: 10px !important;
      height: 65px !important;
      max-height: 65px !important;

      background-color: #403551 !important;
      border-color: #403551 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado3) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #374BDB !important;
      border-color: #374BDB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado3:hover) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #090996 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #BA2D20 !important;
      border-color: #BA2D20 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #741d15 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4VB) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #751b13 !important;
      border-color: #751b13 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4VB:hover) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #4a100b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado5) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #41A1DB !important;
      border-color: #41A1DB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado5:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #002e7e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado6) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #37DBC7 !important;
      border-color: #37DBC7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado6:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #096f94 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado7) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #42DB77 !important;
      border-color: #42DB77 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado7:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #007466 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

}

@media only screen and (min-width: 992px) {

  .tablaTitle {
    font-size: 16px;
    transition: ease 1s;
  }



  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 21px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 21px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 13px;
    transition: ease 1s;
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 11px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonGobColorFicha) {
    background-color: #4a001f;
    // background-color: #8d949e;
    border-color: #4a001f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 13px;
    }
  }

  ::v-deep(.botonGobColorFicha:hover) {
    background-color: #80245f;
    // background-color: #8d949e;
    border-color: #80245f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 15px;
    }
  }

  ::v-deep(.splitGeneracionEstado1) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1:hover) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #333b3b !important;
      border-color: #333b3b !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado1CCP) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #2a4645 !important;
      border-color: #2a4645 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1CCP:hover) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #172d2c !important;
      border-color: #172d2c !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }


  ::v-deep(.splitGeneracionEstado1VB) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #474747 !important;
      border-color: #474747 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1VB:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #232323 !important;
      border-color: #232323 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #7F43DE !important;
      border-color: #7F43DE !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #3f00a3 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2VB) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #491e8e !important;
      border-color: #491e8e !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2VB:hover) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #220e42 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2CCP) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #403551 !important;
      border-color: #403551 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2CCP:hover) {
    .p-component {
      font-size: 10px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #403551 !important;
      border-color: #403551 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado3) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #374BDB !important;
      border-color: #374BDB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado3:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #090996 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #BA2D20 !important;
      border-color: #BA2D20 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #741d15 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4VB) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #751b13 !important;
      border-color: #751b13 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4VB:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #4a100b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado5) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #41A1DB !important;
      border-color: #41A1DB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado5:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #002e7e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado6) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #37DBC7 !important;
      border-color: #37DBC7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado6:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #096f94 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado7) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #42DB77 !important;
      border-color: #42DB77 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado7:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #007466 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

}

@media only screen and (min-width: 1200px) {

  .tablaTitle {
    font-size: 20px;
    transition: ease 1s;
  }



  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 22px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 22px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 16px;
    transition: ease 1s;

    .p-column-title {
      font-size: 16px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 14px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonGobColorFicha) {
    background-color: #4a001f;
    // background-color: #8d949e;
    border-color: #4a001f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 17px;
    }
  }

  ::v-deep(.botonGobColorFicha:hover) {
    background-color: #80245f;
    // background-color: #8d949e;
    border-color: #80245f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 17px;
    }
  }


  ::v-deep(.splitGeneracionEstado1) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #333b3b !important;
      border-color: #333b3b !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado1CCP) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #2a4645 !important;
      border-color: #2a4645 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1CCP:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #172d2c !important;
      border-color: #172d2c !important;
      border-style: dotted;
      transition: ease 1s;
    }

  }

  ::v-deep(.splitGeneracionEstado1VB) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #474747 !important;
      border-color: #474747 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1VB:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #232323 !important;
      border-color: #232323 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #7F43DE !important;
      border-color: #7F43DE !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #3f00a3 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2VB) {
    .p-component {
      font-size: 15px !important;
      height: 60px !important;
      max-height: 60px !important;

      background-color: #491e8e !important;
      border-color: #491e8e !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2VB:hover) {
    .p-component {
      font-size: 15px !important;
      height: 60px !important;
      max-height: 60px !important;

      background-color: #220e42 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2CCP) {
    .p-component {
      font-size: 15px !important;
      height: 60px !important;
      max-height: 60px !important;

      background-color: #644597 !important;
      border-color: #644597 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2CCP:hover) {
    .p-component {
      font-size: 15px !important;
      height: 60px !important;
      max-height: 60px !important;

      background-color: #403551 !important;
      border-color: #403551 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado3) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #374BDB !important;
      border-color: #374BDB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado3:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #090996 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #BA2D20 !important;
      border-color: #BA2D20 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #741d15 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4VB) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #751b13 !important;
      border-color: #751b13 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4VB:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #4a100b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado5) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #41A1DB !important;
      border-color: #41A1DB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado5:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #002e7e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado6) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #37DBC7 !important;
      border-color: #37DBC7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado6:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #096f94 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado7) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #42DB77 !important;
      border-color: #42DB77 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado7:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #007466 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 15px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 15px !important;
      height: 45px !important;
      max-height: 45px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

}

@media only screen and (min-width: 1515px) {

  .tablaTitle {
    font-size: 20px;
    transition: ease 1s;
  }



  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 25px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 25px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 13px;
    transition: ease 1s;

    .p-column-title {
      font-size: 13px
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 13px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonGobColorFicha) {
    background-color: #4a001f;
    // background-color: #8d949e;
    border-color: #4a001f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 17px;
    }
  }

  ::v-deep(.botonGobColorFicha:hover) {
    background-color: #80245f;
    // background-color: #8d949e;
    border-color: #80245f;
    // border-color: #8d949e;
    transition: ease 1s;

    .p-button-icon {
      color: rgb(255, 255, 255);
    }

    .p-button-label {
      font-size: 17px;
    }
  }

  ::v-deep(.splitGeneracionEstado1) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #333b3b !important;
      border-color: #333b3b !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado1CCP) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #2a4645 !important;
      border-color: #2a4645 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1CCP:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #172d2c !important;
      border-color: #172d2c !important;
      border-style: dotted;
      transition: ease 1s;
    }

  }

  ::v-deep(.splitGeneracionEstado1VB) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #474747 !important;
      border-color: #474747 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado1VB:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #232323 !important;
      border-color: #232323 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #7F43DE !important;
      border-color: #7F43DE !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #3f00a3 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2VB) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #491e8e !important;
      border-color: #491e8e !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2VB:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #220e42 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado2CCP) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #644597 !important;
      border-color: #644597 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado2CCP:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #403551 !important;
      border-color: #403551 !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado3) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #374BDB !important;
      border-color: #374BDB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado3:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #090996 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #BA2D20 !important;
      border-color: #BA2D20 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #741d15 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado4VB) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #751b13 !important;
      border-color: #751b13 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado4VB:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #4a100b !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado5) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #41A1DB !important;
      border-color: #41A1DB !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado5:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #002e7e !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado6) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #37DBC7 !important;
      border-color: #37DBC7 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado6:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #096f94 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitGeneracionEstado7) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #42DB77 !important;
      border-color: #42DB77 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitGeneracionEstado7:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #007466 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado8) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #406BD6 !important;
      border-color: #406BD6 !important;
      transition: ease 1s;

    }
  }

  ::v-deep(.splitRecepcionEstado8:hover) {
    .p-component {
      font-size: 15px !important;
      height: 40px !important;
      max-height: 40px !important;

      background-color: #274181 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

}


//Split Button para los Estados Responsivos</style>
